import { Order } from 'protocol/api/billing_new/dto_order_new_pb';

export const findDiagnocoinAdjustmentOrder = (
  orders: Order[],
  requestID: string,
): Order | undefined =>
  orders.find((order) => {
    const effect = order.Effect?.Effect;

    return (
      effect?.case === 'DiagnocoinAdjustment' &&
      effect.value.RequestID === requestID
    );
  });
